// eslint-disable-next-line import/prefer-default-export
export const isEnterPressEvent = (evt) => evt.keyCode === 13;
export const isSpacebarPressEvent = (evt) => evt.keyCode === 32;
